<template>
    <div class="leftMenu">
      <aside id="sidebar-left" class="sidebar-left">
        <div class="sidebar-header">
          <div class="sidebar-title">
            Navegación
          </div>
          <div class="sidebar-toggle hidden-xs" data-toggle-class="sidebar-left-collapsed" 
               data-target="html" data-fire-event="sidebar-left-toggle">
            <i class="fa fa-bars" aria-label="Toggle sidebar"></i>
          </div>
        </div>

        <div class="nano">
          <div class="nano-content">
            <nav id="menu" class="nav-main" role="navigation">
                <ul class="nav nav-main">
                    <li>
                        <router-link to="/">
                            <i class="fa fa-home" aria-hidden="true"></i>
                            <span>Inicio</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/calls">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            <span>Llamadas</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/mails">
                            <i class="fa fa-mail-bulk" aria-hidden="true"></i>
                            <span>Paquetería</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/reservations">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                            <span>Sala de Juntas</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/desks">
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                            <span>Escritorios</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/invoices">
                            <i class="fa fa-file-invoice-dollar" aria-hidden="true"></i>
                            <span>Facturas</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link v-if="$auth.isAuthenticated" to="/features/subscriptions">
                            <i class="fa fa-sign" aria-hidden="true"></i>
                            <span>Subscripciones</span>
                        </router-link>
                    </li>
                    <!--
                    <li>
                        <router-link to="/features/contact">
                            <i class="fa fa-envelope-open" aria-hidden="true"></i>
                            <span>Enviar Mensaje</span>
                        </router-link>
                    </li>-->

                </ul>
            </nav>
          </div>
        </div>
      </aside>     
    </div>
</template>

<script>
    export default {
        name: 'LeftMenu',
        data: function () {
            return {
                isLoading : true               
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                
            });
        },
        methods: {
            
        }
    }
</script>